export default __webpack_public_path__ + "de0df332f9a91c0bc0eba3e5424dac74.png";